import { DeliveryModeData } from 'types';

const STORES_TO_SHOW_CARRIER = ['100', '301753'];

interface Props {
  store: string;
  deliveryMode: DeliveryModeData;
}

export function getDeliveryDisplay({ store, deliveryMode }: Props) {
  const carrierName = deliveryMode?.name;
  const shouldShowCarrierName = STORES_TO_SHOW_CARRIER.includes(store);

  return shouldShowCarrierName && carrierName
    ? carrierName
    : 'Entrega pela loja';
}
